import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { ProductSegmentService } from '../product-segment.service';

@Component({
  selector: 'itpx-product-segment-add',
  templateUrl: './product-segment-add.component.html',
  styleUrls: ['./product-segment-add.component.css']
})
export class ProductSegmentAddComponent implements OnInit {

    private fields: any[];
    private cancelRoute: string = '/agora/product-data/product-segments';

    constructor(
        private service: ProductSegmentService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router
    ) { }

    ngOnInit() {
        this.fields = this.service.getFields();
    }

    private onSaveFinished(data: any) {
        this.service.add(this.service.formatData(data))
        .subscribe(
            body => {
                const response = body['data'];
                this.notificationService.success('Successfully created the product segment', 'Success');
                this.router.navigate(['/agora/product-data/product-segments/']);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-segments/add/product-segment-add.component.ts